import styled from "styled-components/macro";

export const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;

  transform: translateX(-50%) translateY(-50%);
  border-radius: 15px;
  border: 3px solid var(--grey-2);
  background: var(--menu-color);
  padding: 25px;

  width: 500px;

  color: var(--grey-0);
  z-index: 50000;

  p {
    margin-bottom: 1.5rem;
  }

  a {
    position: absolute;
    top: 10px;
    right: 10px;
    color: var(--grey-1);
    font-size: 12px;
  }

  dl {
    section {
      display: flex;
      margin-bottom: 10px;
      dt {
        width: 175px;
        span {
          float: right;
          background: var(--grey-3);
          padding: 3px 6px;
          margin-right: 5px;
          border-radius: 3px;
          color: var(--grey-1);
          font-size: 13px;
          position: relative;
          top: 2px;
        }
      }

      dd {
        padding: 3px 6px;
      }
    }
  }
`;
